<template>
<div>
  <v-card
      class="mx-auto"
      elevation="0"
  >
    <v-card-title class="card-header-add fixed-card-title">
      <v-row dense>
        <v-col class="d-flex align-center justify-start" cols="6">
          {{$t('edit-licence')}}
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end">
          <span class="font-size15 mr-2">{{selectedLicense.isActive ? $t('active') : $t('inactive')}}</span>
          <v-switch @change="changeLicenceStatus" v-model="selectedLicense.isActive" hide-details class="mt-n1 mr-3 ">
          </v-switch>
          <v-icon  color="white" @click="closeDrawer">mdi-close</v-icon>
        </v-col>
      </v-row>
    </v-card-title>
    <v-container class="mt-16">
<!--      <span>{{selectedLicense.licenceName}}</span>-->
      <v-text-field class="my-2" disabled v-model="selectedLicense.licenseName" :label="$t('license-name')" dense hide-details outlined/>
      <v-text-field class="my-2" disabled v-model="selectedLicense.licenseType" :label="$t('license-type')" dense hide-details outlined/>
      <v-text-field class="my-2"  disabled v-model="selectedLicense.licenseDescription" :label="$t('license-description')" dense hide-details outlined/>
      <v-text-field class="my-2" disabled  v-model="selectedLicense.isLicenseAssigned" :label="$t('license-assigned')" dense hide-details outlined/>
      <v-text-field type="number" class="my-2"  v-model="selectedLicense.price" :label="$t('license-price')" dense hide-details outlined/>
    </v-container>
  </v-card>
  <v-card-actions class="fixed-card-actions">
    <v-row class="mb-0">
      <v-col cols="6">
        <v-btn
            @click="closeDrawer"
            elevation="0"
            class="cancel-button-style capitalize-text"
        >
          {{$t('cancel')}}
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
            :disabled="!selectedLicense.price"
            @click="save"
            class="save-button-style"
        >
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card-actions>

</div>
</template>
<script>
import { mapState } from 'vuex';
import { showErrorAlert, showSuccessAlert } from '@/utils/utilities';

export default {
  name: 'EditLicenseDrawer.vue',
  methods: {
    async changeLicenceStatus () {
      this.selectedLicense.price = parseInt(this.selectedLicense.price);
      try {
        const response = await this.$store.dispatch('licenses/editLicensesForOrganization', this.selectedLicense);
        if (response.resFlag) {
          const index = this.licenses.findIndex(l => l.id === response.data.id);
          if (index > -1) {
            this.licenses.splice(index, 1, response.data);
            showSuccessAlert(response.msg);
          }
        }
      } catch (error) {
        showErrorAlert(error.response.data.msg);
      }
    },
    closeDrawer () {
        this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
        this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
    },
    async save () {
      // this.selectedLicense.price = parseInt(this.selectedLicense.price);
      try {
        const updatedLicense = await this.$store.dispatch('licenses/editLicensesForOrganization', this.selectedLicense);
        const index = this.licenses.findIndex(l => l.id === updatedLicense.data.id);
        if (index > -1) {
          this.licenses.splice(index, 1, updatedLicense.data);
        } else {
          this.licenses.push(updatedLicense.data); // fallback if not found
        }
      } catch (err) {
        return err;
      }
      this.closeDrawer();
    },
  },
  computed: {
    ...mapState({
      selectedLicense: (state) => state.licenses.selectedLicense,
      licenses: state => state.licenses.licenses,
    }),
  },
};
</script>
